"use strict";'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var chunkLXX3SSRV_js = require('./chunk-LXX3SSRV.js');
var o = require('styled-components');
var faChevronDown = require('@fortawesome/free-solid-svg-icons/faChevronDown');
var reactAccordion = require('@radix-ui/react-accordion');
var jsxRuntime = require('react/jsx-runtime');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var o__default = /*#__PURE__*/_interopDefaultLegacy(o);

var g=`
  --accordion-header-background: var(--color-neutral-50);
  --accordion-header-color: var(--color-neutral-800);
  --accordion-content-background: var(--color-neutral-0);

  [data-theme='dark'] & {
    --accordion-header-background: var(--color-neutral-500);
    --accordion-header-color: var(--color-neutral-50);
    --accordion-content-background: var(--color-neutral-400);
  }
`,h=`
  --accordion-header-color: var(--color-neutral-800);

  [data-theme='dark'] & {
    --accordion-header-color: var(--color-neutral-50);
  }
`,e="cubic-bezier(0.87, 0, 0.13, 1)",m=o.keyframes`
  from {
    height: 0;
  }

  to {
    height: var(--radix-accordion-content-height);
  }
`,p=o.keyframes`
  from {
    height: var(--radix-accordion-content-height);
  }
  to {
    height: 0;
  }
`,u=o__default["default"](reactAccordion.Root)`
  ${({$unstyled:r=!1})=>r?h:g}
`,f=o__default["default"](reactAccordion.Header)`
  display: flex;
  background: var(--accordion-header-background);
  color: var(--accordion-header-color);
  font-size: var(--font-size-regular);
  font-weight: var(--font-weight-bold);
  height: 35px;
  margin: 0;
  padding: 0 16px;
`,v=o__default["default"](reactAccordion.Item)`
  overflow: hidden;
`,b=o__default["default"](chunkLXX3SSRV_js.b).attrs({icon:faChevronDown.faChevronDown,size:"small"})`
  transition: transform 200ms ${e};

  [data-state='open'] & {
    transform: rotate(180deg);
  }
`,x=o__default["default"](reactAccordion.Trigger).attrs(({children:r})=>({children:jsxRuntime.jsxs(jsxRuntime.Fragment,{children:[r,jsxRuntime.jsx(b,{})]})}))`
  all: unset;
  align-items: center;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  width: 100%;
`,k=o__default["default"](reactAccordion.Content)`
  background: var(--accordion-content-background);

  &[data-state='open'] {
    animation: ${m} 200ms ${e};
  }

  &[data-state='closed'] {
    animation: ${p} 200ms ${e};
  }
`,y={Root:u,Header:f,Item:v,Trigger:x,Content:k};

exports.a = y;
